import { useEffect } from 'react';
import { messaging } from '../firebase';
import { getToken, onMessage } from 'firebase/messaging';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const usePushNotifications = () => {
  useEffect(() => {
    const registerPush = async () => {
      if (!('Notification' in window)) {
        console.warn('🚫 Este navegador não suporta notificações push.');
        return;
      }

      try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          console.warn('🔕 Permissão de notificação negada pelo usuário.');
          return;
        }

        const vapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;
        if (!vapidKey || typeof vapidKey !== 'string') {
          console.error('❌ VITE_VAPID_PUBLIC_KEY ausente ou inválida.');
          return;
        }

        const currentToken = await getToken(messaging, { vapidKey });

        if (!currentToken) {
          console.warn('⚠️ Token FCM não obtido.');
          return;
        }

        console.log('✅ Token FCM:', currentToken);

        const response = await fetch('/api/push/token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: currentToken }),
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Erro ao salvar token: ${errorText}`);
        }

        console.log('📡 Token salvo com sucesso!');
      } catch (error) {
        console.error('❌ Erro no registro de push:', error);
      }
    };

    registerPush();

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('📩 [FOREGROUND] Notificação recebida:', payload);

      const title = payload.notification?.title || 'MIF Kids';
      const body = payload.notification?.body || '';
      const url = payload.notification?.click_action || payload.data?.url || '/';

      toast.info(
        <div onClick={() => window.location.href = url} style={{ cursor: 'pointer' }}>
          <strong>{title}</strong>
          <div>{body}</div>
        </div>,
        {
          icon: '/pwa-192x192.png',
          autoClose: false,
          closeOnClick: true,
          pauseOnHover: true,
        }
      );

      // 🔊 Som opcional
      try {
        const audio = new Audio('/notificacao.mp3');
        audio.play().catch(() => {});
      } catch {}
    });

    return () => {
      if (unsubscribe && typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);
};

export default usePushNotifications;
